import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { PlatformPrivateServices } from '../../../PlatformPrivateServices';
import { BaseComponent } from './BaseComponent';
import {
  ComponentsNamespaceErrorCode,
  createComponentsNamespaceError,
} from '../errors';

interface IImageComponentProps {
  src: string;
}
export class ImageComponent extends BaseComponent<IImageComponentProps> {
  readonly #compRef: ComponentRef;
  readonly #ps: PlatformPrivateServices;
  readonly #state: {
    src?: string | null;
  } = {};

  public type = 'image';

  constructor(public compRef: ComponentRef, ps: PlatformPrivateServices) {
    super();

    this.#compRef = compRef;
    this.#ps = ps;

    this.#init();
  }

  #init() {
    const data = this.#ps.ds.components.data.get(this.#compRef);
    this.#state.src = data?.image?.uri || data?.uri;
  }

  getProp<K extends keyof IImageComponentProps>(prop: K) {
    switch (prop) {
      case 'src': {
        return this.#state.src;
      }

      default: {
        return null;
      }
    }
  }

  setProp<K extends keyof IImageComponentProps>(
    prop: K,
    value: IImageComponentProps[K] | null | undefined,
  ) {
    switch (prop) {
      case 'src': {
        this.#state.src = value;

        const data = this.#ps.ds.components.data.get(this.#compRef);

        // Image and ImageX have different JSON schema,
        // that's why we need to pass different data to verify that it works in both Editors
        // Search for `"Image": {` or `"ImageX": {` in the link below
        // https://github.com/wix-private/monorepo/blob/26a7c8253d85827a4881f7d1b27182574f6764f4/editor_server/wix-html-server/wix-html-editor/wix-html-editor-scripts/src/main/resources/json_schemas/restricted/document_data.json
        if (data.type === 'Image') {
          this.#ps.ds.components.data.update(this.#compRef, {
            ...data,
            uri: value,
          });
        } else {
          this.#ps.ds.components.data.update(this.#compRef, {
            ...data,
            image: {
              ...data.image,
              uri: value,
            },
          });
        }

        return;
      }

      default: {
        throw createComponentsNamespaceError(
          ComponentsNamespaceErrorCode.UnknownSetProp,
          'image components supports only "src" property',
        );
      }
    }
  }
}
